import Vue from 'vue'
import { LiveChatWidget } from '@livechat/widget-vue/v2'

Vue.component('LiveChat', LiveChatWidget)

